import { render } from "./AddMatch.vue?vue&type=template&id=b37dc7a8&scoped=true&ts=true"
import script from "./AddMatch.vue?vue&type=script&lang=ts"
export * from "./AddMatch.vue?vue&type=script&lang=ts"

import "./AddMatch.vue?vue&type=style&index=0&id=b37dc7a8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37dc7a8"]])

export default __exports__